/**
 * 카드(PG) 결제 한도 — 상품 1개 · 1회 · 1일. 본사 전용.
 * 한도를 실제로 거는 곳은 자사몰 서버다(주문 · 결제창 생성). 여기서는 값을 고치기만 한다.
 */
import api from './index'

export function getCardPaymentLimit() {
  return api.get('/api/v1/payment-limits/card')
}

/**
 * @param {Object} data - { perProductMaxAmount, perPaymentMaxAmount, dailyMaxAmount, activeYn, memo }
 *   금액 칸은 null 이면 그 한도가 없다.
 */
export function saveCardPaymentLimit(data) {
  return api.put('/api/v1/payment-limits/card', data)
}
